const appURL =
  process.env.NODE_ENV === "production"
    ? "https://app.flowrota.com"
    : `http://${window.location.hostname}:3000`;

export default appURL;
